import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Table from '../../../common/Table';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { filterMethodCaseInsensitive } from '../../../../utils/filter-methods';
import { getLegalManifestBaggageDetail } from '../../../../actions/legal/LegalManifestBaggage';
import { LEGAL_MANIFEST_BAGGAGE_DETAIL_COLUMNS } from '../../../../config/columns';

const LegalManifestBaggagesDetail = ({ idSourceSystem, dispatchGetLegalManifestBaggageDetail,
}) => {

  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDetails = async () => {
      setLoading(true);
      const result = await dispatchGetLegalManifestBaggageDetail(idSourceSystem);
      setDetails(Array.isArray(result) ? result : []);
      setLoading(false);
    };

    fetchDetails();

  }, [])


  return (
    <>
      <h3>Detalle de Manifiesto de Equipaje</h3>
      <Table
        manual={false}
        columns={LEGAL_MANIFEST_BAGGAGE_DETAIL_COLUMNS}
        data={details}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        filterable
        defaultFilterMethod={filterMethodCaseInsensitive}
        loading={loading}
      />
    </>
  )
}

LegalManifestBaggagesDetail.propTypes = {
  idSourceSystem: PropTypes.string.isRequired,
  dispatchGetLegalManifestBaggageDetail: PropTypes.func.isRequired,
}

const mapDispatchToProps = {
  dispatchGetLegalManifestBaggageDetail: getLegalManifestBaggageDetail,
}

export default connect(null, mapDispatchToProps)(LegalManifestBaggagesDetail)
